import React, { useState } from "react";
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  FaFileCode,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import Logo from "../assets/Logo.png";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className=" m fixed z-10 w-full h-[80px] flex bg-[#0a192f] justify-between items-center px-4  ">
      <div>
        <img
          src={Logo}
          alt="Logo Image"
          style={{ height: "80px", padding: "5px 30px ", zIndex: 1000 }}
        />
      </div>
      {/* Menu */}

      <ul className="md:flex hidden navbar">
        <li>
          <Link to="home" spy={true} smooth={true} duration={300}>
            Home
          </Link>
        </li>
        <li>
          <Link to="about" spy={true} smooth={true} duration={300}>
            About
          </Link>
        </li>

        <li>
          <Link to="skills" smooth={true} offset={-90} duration={300}>
            Skills
          </Link>
        </li>
        <li>
          <Link to="work" spy={true} smooth={true} offset={-90} duration={300}>
            Work
          </Link>
        </li>
        <li>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={-40}
            duration={300}
          >
            Contact
          </Link>
        </li>
      </ul>

      {/* Burger  */}
      <div onClick={() => handleClick()} className="md:hidden z-10">
        {!nav ? <FaBars size={30} /> : <FaTimes size={30} />}
      </div>
      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? "hidden"
            : "    absolute  top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center text-red"
        }
      >
        <li className="py-6 text-4xl">
          <Link
            onClick={() => handleClick()}
            to="home"
            spy={true}
            smooth={true}
            duration={300}
          >
            Home
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link
            onClick={() => handleClick()}
            to="about"
            spy={true}
            smooth={true}
            duration={300}
          >
            About
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link
            onClick={() => handleClick()}
            to="skills"
            spy={true}
            smooth={true}
            duration={300}
          >
            Skills
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link
            onClick={() => handleClick()}
            to="work"
            spy={true}
            smooth={true}
            duration={300}
          >
            Work
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link
            onClick={() => handleClick()}
            to="contact"
            spy={true}
            smooth={true}
            duration={300}
          >
            Contact
          </Link>
        </li>
      </ul>
      {/* Social links*/}
      <div className=" hidden  lg:flex  fixed flex-col top-[35%] left-0">
        <ul>
          <li className=" w-[160px] h-[60px]  ml-[-100px] flex justify-between items-center hover:ml-[0px] duration-300 bg-[#333]">
            <a
              className="flex  w-full justify-between items-center text-xl text-gray-300 "
              href="https://github.com/alesmazur"
              target="blank"
            >
              GitHub <FaGithub size={30} />
            </a>
          </li>
          <li className=" w-[160px] h-[60px] ml-[-100px] flex justify-between items-center hover:ml-[0px] duration-300 bg-[#0E76A8]">
            <a
              className="flex  w-full justify-between items-center text-xl text-gray-300 "
              href="https://www.linkedin.com/in/aliesmazur/"
              target="blank"
            >
              Likedin <FaLinkedin size={30} />
            </a>
          </li>

          <li className=" w-[160px] h-[60px] ml-[-100px] flex justify-between items-center hover:ml-[0px] duration-300 bg-[#430297]">
            <a
              className="flex  w-full justify-between items-center text-xl text-gray-300 "
              href="mailto: alexandrmazurkevich@yahoo.com"
              target="blank"
            >
              Mail <HiOutlineMail size={30} />
            </a>
          </li>
          <li className=" w-[160px] h-[60px] ml-[-100px] flex justify-between items-center hover:ml-[0px] duration-300 bg-[#F40F02]">
            <a
              className="flex  w-full justify-between items-center text-xl text-gray-300 "
              href="https://docs.google.com/document/d/1t7Lz9gEFcIWO41r1HpylqC8GkLgk6Tf9/edit?usp=share_link&ouid=112931912568469996496&rtpof=true&sd=true"
              target="blank"
            >
              Resume <FaFileCode size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
